module.exports = "../../app/cells/components/modals/weekly_activity_modal_cell.rb";